import styled, { css } from 'styled-components';

import { IconManager } from '@speeki/icons';

export const ProfileItemWrapper = styled.div`
    padding-bottom: 16px;
`;

export const Divider = styled.div<{ isMobile?: boolean }>(
    ({ isMobile, theme: { palette } }) => css`
        background: ${palette.neutral.dividers};
        height: 1px;
        margin-bottom: 16px;
        width: ${isMobile ? '100vw' : '100%'};
    `,
);

export const ActionWrapper = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    padding: 0 4px;
`;

export const StyledIcon = styled(IconManager)<{ isMobile?: boolean }>(
    ({ isMobile }) => css`
        margin-right: ${isMobile ? '20px' : '12px'};
    `,
);

export const ArrowIcon = styled(IconManager)`
    margin-left: auto;
`;
